import React, { FC, useMemo } from "react";
import { ICashFlowData } from "types";
import { Table } from "components/Table/Table";
import { formatDate, formatSum } from "utils/format";
import styles from "../ContractPayouts/ContractPayouts.module.scss";
import { MobileCashFlows } from "../MobileCashFlows/MobileCashFlows";

const columns = [
  {
    title: "Дата операции",
    key: "dateCashFlow",
  },
  {
    title: "Тип операции",
    key: "typeOperation",
  },
  { title: "Сумма", key: "sum", render: formatSum },
  { title: "НДФЛ", key: "ndfl", render: formatSum },
  { title: "К оплате", key: "toPay", render: formatSum },
  {
    title: "Фактическая дата оплаты",
    key: "factPaymentDate",
   
  },
  { title: "Оплачено ФЛ", key: "factPaid", render: formatSum },
  { title: "Оплачено НДФЛ", key: "factPaidNdfl", render: formatSum },
  { title: "Всего оплачено", key: "paid", render: formatSum },
];

export const CashFlowsTable: FC<{ data: ICashFlowData[] }> = ({ data }) => {
  const formattedData = data.map((item, index) => ({
    key: index,
    value: {
      dateCashFlow: formatDate(item.dateCashFlow),
      typeOperation: item.typeOperation,
      sum: formatSum(item.sum),
      ndfl: formatSum(item.ndfl),
      toPay: formatSum(item.toPay),
      factPaymentDate: formatDate(item.factPaymentDate),
      factPaid: formatSum(item.factPaid),
      factPaidNdfl: formatSum(item.factPaidNdfl),
      paid: formatSum(item.paid),
    },
  }));

  const tableData = useMemo(() => {
    return formattedData;
  }, [formattedData]);

  return (
    <div className={styles.ContentWrapper}>
      <div className={styles.tableWrapper}>
        <Table
          uniqueKey="idFlow"
          data={tableData}
          columns={columns}
          className={styles.table}
        />
      </div>
      <MobileCashFlows data={data} className={styles.mobileDetails} /> 
    </div>
  );
};
